import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiTokenService } from '@services/api-token.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FunctService }  from "@services/index";
import { NgModel } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-otpsetting',
  templateUrl: './otpsetting.component.html',
  styleUrls: ['./otpsetting.component.scss']
})
export class OTPSettingComponent implements OnInit {

  otpChannelList: any[] = [];
  selectedChannel: any={};
  @ViewChild('emailRef')
  emailRef!: NgModel;
  email: any= null;
  phoneNo: any= '';
  constructor( 
    private storage: LocalStorageService,
    private apiTokenServer: ApiTokenService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService, 
    private funct: FunctService,
    private translateService: TranslateService,  ) { }

  ngOnInit(): void {
    const prefix = this.storage.retrieve('localPhonePrefix');
    const phone = this.storage.retrieve('localPhoneValue');
    
    if (phone.startsWith('0')) {
      this.phoneNo = prefix + phone.substring(1, phone.length);
    }
    if (phone.startsWith('+95')) {
      this.phoneNo = phone;
    }
    else {
      this.phoneNo = prefix + phone;
    }
    this.getOtpChannelList();
  }

  getOtpChannelList() {    
    this.apiTokenServer.get(`otpChannel/getOTPChannelList?phone_no=${encodeURIComponent(this.phoneNo)}`)
    .then(async (response: any)=> {         
      if(response.status == 200){       
        if(this.funct.fileName === "crazy"){
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].icon_url =  response.data[i].icon_url.replace('lucky2d', 'crazybossy');
          }
        }  
        console.log('OTP Channel List:', response.data);
        this.otpChannelList = response.data;
        for (let j = 0; j < response.data.length; j++) {
          if (response.data[j].is_default) {
            this.selectedChannel = response.data[j];
            break;
          }
        }
      }else{
         this.toastr.error("", response.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
          return;    
      }             
        
   })          
   .catch(async error=> {            
      this.toastr.error("", error.response.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
        return;   
   });  
  }
  trackByOtpChannelList(index: number, item: any): number {
    return item.channel_id; 
  }

  onSelectOtpChannel(channel: any){
    this.selectedChannel = channel;   
  }
  checkEmail() { 
    if(this.email === null || this.email === undefined || this.email.trim() === ''){
      var required = this.translateService.instant("requiredFiled");
      required=required.toString().replace("{{value}}",  this.translateService.instant('email_address'));
      this.toastr.warning("", required, {
        timeOut: 3000,
        positionClass: 'toast-top-center',
      });
      
      return;
    }   
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var check = pattern.test(this.email);
    
    if(check){
      this.emailRef.control.setErrors(null);
    }else{
      this.emailRef.control.setErrors({ 'invalidEmail': true });
    }  
  }

  onSaveOtpSetting() {    
     if(this.selectedChannel.channel_code === 'EMAIL' && this.selectedChannel.destination === null && this.email == null){
      this.checkEmail();
      return;
     }
     if(this.email !== null && this.email !== undefined && this.email.trim() !== '') {
      this.selectedChannel.destination = this.email;
     }      
     var model= {
        phone_no: this.phoneNo,
        is_default: true,
        channel_code: this.selectedChannel.channel_code,
        destination: this.selectedChannel.destination
      } 
       
      this.apiTokenServer.post(`userOtpSetting/insert`, model)
          .then(async (response: any)=>{
            console.log('Save OTP Setting Response:', response);
            if(response.status == 200){       
              this.toastr.success("", response.data.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              this.getOtpChannelList();              
            }else{
              this.toastr.error("", response.data.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              return; 
            }
          }).catch((err: any)=>{
              this.toastr.error("", err.response.data.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              return; 
      });
  }
   

  
}
